import angular from 'angular';

/**
 * @ngdoc overview
 * @name adminModule.appsServices
 * @description
 * # adminModule.appsServices
 * Module for managing the services of: apps/SDKs. For $http requests, API calls.
 */
const appsServices = angular.module('adminModule.appsServices', []);

/**
 * @ngdoc interface
 * @name adminModule.appsServices.interface:App
 * @description
 * Service for handling API connections of Apps/SDKs.
 */
appsServices.factory('App', ['$http', 'AppsoupAPI', 'Upload', function ($http, AppsoupAPI, Upload) {
    'use strict';

    const API_URL = `${AppsoupAPI.API_URL}/app/`;

    return {
        get: (appId) => {
            return $http.get(`${API_URL}${appId}`);
        },
        save: (app, editMode, file) => {
            if (editMode) {
                if (angular.isDefined(file)) {
                    const newfields = angular.extend(app, {_method: 'PUT'});

                    return Upload.upload({
                        url: `${API_URL}${app.id}`,
                        method: 'POST',
                        sendObjectsAsJsonBlob: false,
                        fields: newfields,
                        file: file
                    });
                } else {
                    return $http.put(`${API_URL}${app.id}`, app);
                }
            } else {
                return $http.post(API_URL, app);
            }
        },
        remove: (appId) => {
            return $http.delete(`${API_URL}${appId}`);
        },
        removeAttribute: (appId, key, module) => {
            return $http.delete(`${API_URL}${appId}/module/${module}/attribute`, {params: {key}});
        },
        saveAttribute: (app, module, editAttrMode, attr) => {
            if (editAttrMode) {
                return $http.put(`${API_URL}${app}/module/${module}/attribute`, attr);
            } else {
                return $http.post(`${API_URL}${app}/module/${module}`, attr);
            }
        },
        getList: (params, clientId) => {
            const url = `${API_URL}${angular.isDefined(clientId) ? `client-permitted/${clientId}` : ''}`;

            return $http.get(url, {params: AppsoupAPI.getTableParams(params)}).then((response) => {
                return response.data;
            });
        },
        getAutocompleteList: (query, clientId) => {
            return $http.get(`${API_URL}autocomplete`, {params: {name: query, client_id: clientId}});
        },
        getForm: () => {
            return $http.get(`${API_URL}create`);
        },
        getAttributeTypes: () => {
            return $http.get(`${API_URL}attribute-types`);
        },
        getModuleTypes: () => {
            return $http.get(`${API_URL}module-types`);
        },
        checkPermissions: (appId) => {
            return $http.get(`${API_URL}${appId}/permissions`).then((response) => {
                return response.data;
            });
        },
        getMenu: (params) => {
            const url = `${API_URL}menu`;

            return $http.get(url, {params: AppsoupAPI.getTableParams(params)}).then((response) => {
                return response.data;
            });
        }
    };
}]);

appsServices.factory('Page', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const PAGE_URL = `${AppsoupAPI.API_URL}/page/`;

    return {
        getList: (appId) => {
            return $http.get(PAGE_URL, {params: {application_id: appId}});
        },
        save: (page, editMode) => {
            if (editMode) {
                return $http.put(`${PAGE_URL}${page.id}`, page);
            } else {
                return $http.post(PAGE_URL, page);
            }
        },
        remove: (pageId) => {
            return $http.delete(`${PAGE_URL}${pageId}`);
        }
    };
}]);

appsServices.factory('Module', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = `${AppsoupAPI.API_URL}/module/`;

    return {
        save: (module, editMode) => {
            if (editMode) {
                return $http.put(`${API_URL}${module.id}`, module);
            } else {
                return $http.post(API_URL, module);
            }
        },
        remove: (moduleId) => {
            return $http.delete(`${API_URL}${moduleId}`);
        },
        getModalData: () => {
            const API_URL_MODAL = `${API_URL}create/`;

            return $http.get(API_URL_MODAL);
        }
    };
}]);

appsServices.factory('ModuleElement', ['$http', 'Upload', 'AppsoupAPI', function ($http, Upload, AppsoupAPI) {
    'use strict';

    const API_URL = `${AppsoupAPI.API_URL}/module-element/`;

    return {
        newLevel: (placeId, levelName, clientId, file) => {
            return Upload.upload({
                url: API_URL,
                method: 'POST',
                headers: {'Content-Type': file.type},
                sendObjectsAsJsonBlob: true,
                fields: {
                    place_id: placeId,
                    name: levelName,
                    client_id: clientId
                },
                file: file
            });
        },
        save: (module_element, editMode, file) => {
            if (editMode) {
                if (angular.isDefined(file)) {
                    return Upload.upload({
                        url: `${API_URL}${module_element.id}`,
                        method: 'PUT',
                        fields: module_element,
                        file: file
                    });
                } else {
                    return $http.put(`${API_URL}${module_element.id}`, module_element);
                }
            } else {
                if (angular.isDefined(file)) {
                    return Upload.upload({
                        url: API_URL,
                        method: 'POST',
                        headers: {'Content-Type': file.type},
                        sendObjectsAsJsonBlob: true,
                        fields: module_element,
                        file: file
                    });
                } else {
                    return $http.post(API_URL, module_element);
                }
            }
        }
    };
}]);

export default appsServices;
